import React from 'react'
import Bredcom from '../../Bredcom/Main'
import First from '../Menprojects/First'

function Main() {
  return (
    <>  
        <Bredcom title="Gallery" subtitle="Home" subtitledown="Pricing"/>
        <First/>
    </>
  )
}

export default Main